import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Instagram, Facebook, Youtube } from "lucide-react";
import { useSettings } from "@/lib/settings";

export default function Footer() {
  const { settings } = useSettings();
  const s = settings || {};
  return (
    <footer className="bg-[#171717] mt-20 border-t-4 border-[#FF9418]" data-testid="site-footer" style={{ color: "#E5E5E5" }}>
      <div className="max-w-7xl mx-auto px-4 py-14 grid gap-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="inline-block bg-white p-3 rounded-lg mb-4">
            <img src="/logo.png" alt="Teknik Diesel Indonesia" className="h-14 w-auto" style={{ maxWidth: "220px" }} />
          </div>
          <p className="text-[#B5B5B5] text-sm leading-relaxed">
            Penyedia mesin industri, kompresor portable, bar bender, bar cutter, spare parts, dan layanan servis mesin.
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold text-white mb-4 text-sm uppercase tracking-wider">Produk</h4>
          <ul className="space-y-2 text-sm text-[#B5B5B5]">
            <li><Link to="/produk?category=Portable Air Compressor" className="hover:text-[#FF9418]" data-testid="footer-link-kompresor">Kompresor Airman</Link></li>
            <li><Link to="/produk?category=Bar Bender" className="hover:text-[#FF9418]" data-testid="footer-link-bar-bender">Bar Bender</Link></li>
            <li><Link to="/produk?category=Bar Cutter" className="hover:text-[#FF9418]" data-testid="footer-link-bar-cutter">Bar Cutter</Link></li>
            <li><Link to="/produk?category=Bar Roller" className="hover:text-[#FF9418]">Bar Roller</Link></li>
            <li><Link to="/produk?category=Produk Industrial" className="hover:text-[#FF9418]">Cairan Anti Api</Link></li>
            <li><Link to="/spare-parts" className="hover:text-[#FF9418]">Spare Parts</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-white mb-4 text-sm uppercase tracking-wider">Brand</h4>
          <ul className="space-y-2 text-sm text-[#B5B5B5]">
            <li><Link to="/brand/airman" className="hover:text-[#FF9418]" data-testid="footer-brand-airman">Airman</Link></li>
            <li><Link to="/brand/takeda" className="hover:text-[#FF9418]" data-testid="footer-brand-takeda">Takeda</Link></li>
            <li><Link to="/brand/toyo" className="hover:text-[#FF9418]" data-testid="footer-brand-toyo">Toyo</Link></li>
            <li><Link to="/brand/akurad" className="hover:text-[#FF9418]" data-testid="footer-brand-akurad">Akurad</Link></li>
          </ul>
          <h4 className="font-display font-bold text-white mb-3 mt-6 text-sm uppercase tracking-wider">Informasi</h4>
          <ul className="space-y-2 text-sm text-[#B5B5B5]">
            <li><Link to="/tentang-kami" className="hover:text-[#FF9418]">Tentang Kami</Link></li>
            <li><Link to="/service" className="hover:text-[#FF9418]">Service</Link></li>
            <li><Link to="/hubungi-kami" className="hover:text-[#FF9418]">Hubungi Kami</Link></li>
            <li><Link to="/produk" className="hover:text-[#FF9418]">Katalog Produk</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-white mb-4 text-sm uppercase tracking-wider">Kontak</h4>
          <ul className="space-y-2.5 text-sm text-[#B5B5B5]">
            {s.address && <li className="flex items-start gap-2"><MapPin size={14} className="text-[#FF9418] mt-0.5 shrink-0" /> {s.address}</li>}
            {s.phone && <li className="flex items-center gap-2"><Phone size={14} className="text-[#FF9418] shrink-0" /> {s.phone}</li>}
            {s.email && <li className="flex items-center gap-2"><Mail size={14} className="text-[#FF9418] shrink-0" /> {s.email}</li>}
            {s.business_hours && <li className="flex items-center gap-2"><Clock size={14} className="text-[#FF9418] shrink-0" /> {s.business_hours}</li>}
            {!s.address && !s.phone && !s.email && (
              <li className="text-[#737373] text-xs italic">Informasi kontak akan segera tersedia.</li>
            )}
          </ul>
          <div className="flex gap-3 mt-4">
            {s.instagram && <a href={s.instagram} target="_blank" rel="noopener noreferrer" className="text-[#B5B5B5] hover:text-[#FF9418]"><Instagram size={18} /></a>}
            {s.facebook && <a href={s.facebook} target="_blank" rel="noopener noreferrer" className="text-[#B5B5B5] hover:text-[#FF9418]"><Facebook size={18} /></a>}
            {s.youtube && <a href={s.youtube} target="_blank" rel="noopener noreferrer" className="text-[#B5B5B5] hover:text-[#FF9418]"><Youtube size={18} /></a>}
          </div>
        </div>
      </div>

      <div className="border-t border-[#2A2A2A]">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-[#737373]">
          <span>© {new Date().getFullYear()} Teknik Diesel Indonesia — General Technical Supply. All Rights Reserved.</span>
          <span className="font-mono-tech uppercase tracking-widest">teknikdiesel.com</span>
        </div>
      </div>
    </footer>
  );
}
